import React, { Fragment } from 'react';
import { connect } from "react-redux";
import HotKeysModal from 'Components/HotKeysModal';
import { cloneDeep } from 'lodash';
import MySide from './MySide';
import Notice from "Components/Notice";
import MyContent from './MyContent';
import platform from "Pub/js/platform";
import withDragDropContext from "Pub/js/withDragDropContext";
import { langCheck } from "Pub/js/utils";
import AddExternalLink from 'Widgets/ExternalLinks/AddExternalLink';
import { setExternalLinks } from "Store/GridLayout/action";
import { getRepeatItems } from "../../utilService";
const { NCButton } = platform.base;
class DragModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cardList: [],
            showExternalLinks: false,
        };
    }

    handleOk = () => {
        // Ajax
        this.props.onOk(this.state.cardList);
        this.props.onCancel();
    }

    myFooter = ({ OkBtn, CancelBtn }) => {
        return (
            <Fragment>
                {OkBtn}
                <NCButton
                    key="submit"
                    onClick={() => this.setState({ showExternalLinks: true })}
                    fieldid="externalLink"
                >
                    {langCheck("0000PUB-000387")}
                </NCButton>
                {CancelBtn}
            </Fragment>
        );
    }
    // 添加右侧数据 position:向目标位置添加数据
    addCardList = (card, position) => {
        let cardList = cloneDeep(this.state.cardList);
        let newCards = cloneDeep(card);
        const { json, title } = this.props;
        const repeatCards = getRepeatItems(cardList, card, "cardid");
        const repeatCardsAppcodes = repeatCards.map(item => item.appcode);
        if (repeatCards.length) {
            let name = '';
            repeatCards.forEach(item => { name += `${item.name},`; });
            //重复的card删掉
            newCards = card.filter(item => !repeatCardsAppcodes.includes(item.appcode));
            Notice({
                status: "warning",
                msg: `“${title}”${json["DesktopSetting-000057"]}${name}${json["DesktopSetting-000058"]}`, //分组xx内已存在相同应用采购订单、XXX，此次不再重复添加
            });
        }
        //添加到指定位置
        if (position !== undefined) {
            cardList.splice(position, 0, ...newCards);
        } else {
            cardList = cardList.concat(newCards);
        }
        this.setState({ cardList });
    }
    // 右侧列表拖拽排序
    setList = cardList => {
        this.setState({ cardList });
    }
    //数组去重
    arrayUnique = arr => {
        if (!arr) {return;}
        let result = [];
        let obj = {};
        for (let i = 0; i < arr.length; i++) {
            if (!obj[arr[i].cardid]) {
                result.push(arr[i]);
                obj[arr[i].cardid] = true;
            }
        }
        return result;
    };

    //添加外部链接
    handleExternalOk = data => {
        const newData = { ...data, ...{ parttype: "1" } }; //外部链接需要的字段
        this.addCardList([newData]);
        this.props.setExternalLinks(newData); //常用链接存redux
    }

    componentDidMount() {
        const { defaultData } = this.props;
        if (defaultData) {
            this.setState({ cardList: defaultData });
        }
    }
    render() {
        const { cardList, showExternalLinks } = this.state;
        const { title, json, editable } = this.props;
        return (
            <React.Fragment>
                <HotKeysModal
                    maskClosable={false}
                    destroyOnClose={true}
                    title={title}
                    width={1000}
                    height={547}
                    wrapClassName="compact-app-modal"
                    className='app-drag-modal'
                    visible={true}
                    footer={this.myFooter}
                    onOk={this.handleOk}
                    onCancel={this.props.onCancel}
                    fieldid='drag-modal'
                    customTitle={<span className='title-tip'>（{json["DesktopSetting-000063"]}）</span>}
                >
                    <div className="compact-app-container">
                        <MySide json={json} cardList={cardList} />
                        <MyContent
                            addCardList={this.addCardList}
                            cardList={cardList}
                            json={json}
                            setList={this.setList}
                        />
                    </div>
                </HotKeysModal>
                {showExternalLinks && <AddExternalLink
                    onOk={this.handleExternalOk}
                    setShowAddLink={() => { this.setState({ showExternalLinks: false }); }}
                    editable={editable}
                />}
            </React.Fragment>
        );

    }
}
DragModal = connect(
    state => ({ json: state.gridLayoutData.json }),
    { setExternalLinks },
)(DragModal);
export default withDragDropContext(DragModal);